export const SEVEN_PHRASES = [
  'Como baixo meu informe de rendimentos?',
  'Quero receber meu informe por e-mail',
  'Preciso do informe de quem faleceu',
  'Os valores do meu informe não batem',
  'Tenho dúvidas sobre meu IR',
] as const
